import { z } from "zod";

export enum BulkExportData {
  Metadata = "Metadata",
  Media = "Media",
  Transcript = "Transcript",
}

export const schema = z.object({
  customerId: z
    .string({
      required_error: "Customer ID is required.",
    })
    .uuid({
      message: "Invalid customer ID.",
    }),
  interactionIds: z
    .array(z.string())
    .min(2, {
      message: "Must select at least two interactions.",
    })
    .max(100, {
      message: "Cannot export more than 100 interactions.",
    }),
  dataToExport: z
    .array(
      z.object(
        {
          value: z.nativeEnum(BulkExportData),
          label: z.string(),
        },
        {
          required_error: "Data type to export is required.",
        }
      )
    )
    .min(1, {
      message: "Must select at least one data type to export.",
    })
    .default([
      { value: BulkExportData.Media, label: "Media" },
      { value: BulkExportData.Metadata, label: "Metadata" },
      { value: BulkExportData.Transcript, label: "Transcript" },
    ]),
});

export type BulkExportFormValues = z.infer<typeof schema>;
